import { configure, extend } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';

const { DateTime } = require('luxon');

const config = {
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
  mode: 'eager',
};

configure(config);
export default ({ $axios, $config }) => {
  extend('required', {
    ...required,
    message: 'To pole jest wymagane',
  });

  extend('email', {
    ...email,
    message: 'Wprowadź poprawny adres e-mail',
  });

  extend('min', {
    validate(value, args) {
      return value.length >= args.length;
    },
    params: ['length'],
    message: `Minimalna ilość znaków to: {length}`,
  });

  extend('max', {
    validate(value, args) {
      return value.length <= args.length;
    },
    params: ['length'],
    message: `Maksymalna ilość znaków to: {length}`,
  });

  extend('password', {
    params: ['target'],
    validate(value, { target }) {
      return value === target;
    },
    message: 'Wprowadzone hasła różnią się',
  });

  extend('numeric', {
    validate(value, args) {
      return /^([0-9]+)$/.test(value);
    },
    message: `Wartość powinna być liczbą`,
  });

  extend('zipCode', {
    validate(value, args) {
      return /\d{2}-\d{3}/.test(value);
    },
    message: `Nieprawidłowy kod pocztowy`,
  });

  extend('phoneNumber', {
    validate(value, args) {
      return /^\d{3}-\d{3}-\d{3}$/.test(value);
    },
    message: `Nieprawidłowy numer telefonu`,
  });

  extend('phone', {
    validate(value, args) {
      const newVal = value.replace(/\s+/g, '');
      if (value.substring(0, 3) === '+48' && newVal.length === 12) {
        return true;
      } else return value.substring(0, 3) !== '+48' && newVal.length > 4;
    },
    message: `Niepoprawny numer telefonu`,
  });

  extend('size', {
    validate(value, args) {
      const bytes = Number(args.size) * 1024 * 1024;
      if (Array.isArray(value)) {
        return !value.some(file => file.size >= bytes);
      } else {
        return value.size < bytes;
      }
    },
    params: ['size'],
    message: 'Maksymalna wielkość pliku to: {size}MB',
  });

  extend('ext', {
    validate(value, args) {
      if (Array.isArray(value)) {
        return value.every(file => {
          const lastDot = file.name.lastIndexOf('.');
          const extension = file.name.substring(lastDot + 1);

          return !!args.extensions.includes(extension);
        });
      } else {
        const lastDot = value.name.lastIndexOf('.');
        const extension = value.name.substring(lastDot + 1);

        return !!args.extensions.includes(extension);
      }
    },
    params: ['extensions'],
    message:
      'Niedozwolony format pliku. Plik powinien posiadać jedno z tych rozszerzeń: {extensions}',
  });

  extend('costCenter', {
    validate(value, args) {
      if (args.isLimitHard === 'false' || args.exceedanceAllowedAfterApproval === 'true') {
        return true;
      }
      return parseFloat(args.cart) <= parseFloat(args.limit);
    },
    params: ['cart', 'limit', 'isLimitHard', 'exceedanceAllowedAfterApproval'],
    message: `wartość twoich zakupów to: {cart}zł, a twój limit wynosi: {limit}zł`,
  });

  extend('dateRangeRequired', {
    validate(value, args) {
      return !(value.from === null || value.to === null);
    },
    params: ['from', 'to'],
    message: 'Oba pola są wymagane',
  });

  extend('dateRangeCheckFrom', {
    validate(value) {
      const from = DateTime.fromISO(value.from);
      const to = DateTime.fromISO(value.to);
      return to >= from;
    },
    params: ['from', 'to'],
    message: 'Data zakończenia nie może być wcześniejsza niż data rozpoczęcia',
  });

  extend('validateUserDeliveryDate', {
    params: ['selectedDeliveryDate', 'deliveryAddressId', 'insufficientStockDecision'],
    // eslint-disable-next-line space-before-function-paren
    validate: async (
      value,
      { selectedDeliveryDate, insufficientStockDecision, deliveryAddressId },
    ) => {
      try {
        const response = await $axios.get(
          `${$config.baseOfixApi}/e-commerce/v1/checkout/validate-user-delivery-date`,
          {
            params: {
              selectedDeliveryDate,
              insufficientStockDecision,
              deliveryAddressId,
            },
          },
        );

        if (response.data.isValidDate) {
          return true;
        } else {
          return response.data.message || 'Wybrany termin dostawy jest niedostępny.';
        }
      } catch (error) {
        return 'Podczas sprawdzania daty dostawy wystąpił błąd.';
      }
    },
  });
};
